export const editorConfiguration = {
  toolbar: [
    'heading',
    '|',
    'fontFamily',
    'fontSize',
    'fontColor',
    'fontBackgroundColor',
    '|',
    'bold',
    'italic',
    'underline',
    'strikethrough',
    '|',
    'alignment',
    '|',
    'numberedList',
    'bulletedList',
    '|',
    'indent',
    'outdent',
    '|',
    'link',
    'blockQuote',
    'insertTable',
    '|',
    'undo',
    'redo',
  ],
};

export const TINY_API_KEY = 'r3fs7f1ijdgsnoiupcj96yex78je9addexmbzn9l8wdlrcge';

// Helper to remove newlines from TinyMCE HTML content
// TinyMCE v8 formats HTML with newlines for readability, which get escaped as \n in JSON
export const cleanTinyMCEContent = (content) => {
  if (typeof content === 'string') {
    // Remove newlines between HTML tags but preserve content
    return content.replace(/>\s*\n\s*</g, '><').trim();
  }
  return content;
};

export const TINY_INIT_CONFIGURATION = {
  min_height: 160,
  menubar: false,
  plugins: [
    'advlist',
    'anchor',
    'autolink',
    'charmap',
    'code',
    'fullscreen',
    'help',
    'image',
    'insertdatetime',
    'link',
    'lists',
    'media',
    'preview',
    'searchreplace',
    'table',
    'visualblocks',
  ],
  toolbar1:
    'styles bold italic bullist numlist blockquote alignleft aligncenter alignright alignjustify link',
  toolbar2:
    'strikethrough hr forecolor pastetext removeformat charmap indent outdent undo redo help',
  content_style:
    "@import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wdth,wght@0,75..100,300..800;1,75..100,300..800&display=swap');",
  setup: function (editor) {
    editor.on('init', function () {
      editor.getBody().style.fontFamily = 'Open Sans, sans-serif';
    });
  },
};

export const CATEGORY_LIST = [
  {
    id: 'Biometric',
    name: 'Biometric Parameters',
  },
  {
    id: 'UrineTool',
    name: 'Urine & Stool',
  },
  {
    id: 'BloodAnalysis',
    name: 'Blood Analysis',
  },
];

export const GROUP_MEASUREMENT_CATEGORY = {
  Biometric: ['BMIWeight', 'BMIHeight'],
  UrineTool: ['UDSProtein', 'UDSGlucose', 'UDSBlood'],
  BloodAnalysis: ['DIASTOLIC', 'DIASTOLIC2', 'SYSTOLIC', 'SYSTOLIC2'],
};

export const SPECIAL_MEASUREMENT = [
  // Urine Dipstick
  'UDSProtein',
  'UDSGlucose',
  'UDSBlood',
  // BMI
  'BMIWeight',
  'BMIHeight',
  // Waist Hip Ratio
  'WaistHipRatioWaist',
  'WaistHipRatioHip',
  // Visual Acuity
  'LeftUnaided',
  'RightUnaided',
  'LeftAided',
  'RightAided',
  // Blood Pressure
  'DIASTOLIC',
  'DIASTOLIC2',
  'SYSTOLIC',
  'SYSTOLIC2',
  // Peripheral (side) Vision Test
  'PVTRight',
  'PVTLeft',
  // Pupil Reflex
  'APRRight',
  'APRLeft',
];
